import React from "react";

const AggregateSection = ({ onSelectProduct }) => {
  const images = Array.from({ length: 12 }, (_, i) => {
    const num = (i + 1).toString().padStart(2, "0");
    return `/images/aggregate/${num}.jpg`;
  });

  return (
    <main className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-4 justify-center gap-4 px-8">
      {images.map((src, index) => (
        <div key={index} className="w-full overflow-hidden cursor-pointer">
          <img
            src={src}
            alt={`Aggregate ${index + 1}`}
            style={{ width: "100%", height: "500px", objectFit: "cover" }}
            onClick={() =>
              onSelectProduct((index + 1).toString().padStart(2, "0"))
            }
          />
        </div>
      ))}
    </main>
  );
};

export default AggregateSection;
